import { render, staticRenderFns } from "./SetInfo.vue?vue&type=template&id=5b9f5e56&scoped=true"
import script from "./SetInfo.vue?vue&type=script&lang=js"
export * from "./SetInfo.vue?vue&type=script&lang=js"
import style0 from "./SetInfo.vue?vue&type=style&index=0&id=5b9f5e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f5e56",
  null
  
)

export default component.exports